module.exports = __webpack_public_path__ + "img/project17_1.png.551fa430.webp";